import React, { useCallback } from "react";
import "../../NetworkDropdown/NetworkDropdown.css";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import "./ConnectWalletButton.css";
import { GlobalStore } from "../../../store/global/GlobalStore";
import { MODAL_SELECTORS } from "../../Modal/instance/modalSelectors";
import { ConnectWallet } from "./ConnectWallet";
import { RainbowKitWalletButtonContainer } from "./elements/RainbowKitWalletButtonContainer";
import { SerializedStyles } from "@emotion/react";

interface RainbowKitWalletButtonProps {
  isInHeader?: boolean;
  border?: "sharp" | "smooth";
  buttonCss?: SerializedStyles;
  buttonText?: string;
  showIcon?: boolean;
}

export const RainbowKitWalletButton: React.FC<RainbowKitWalletButtonProps> = ({
  border,
  buttonCss,
  buttonText,
  isInHeader,
  showIcon = true,
}) => {
  const makeZerionPlayBall = useCallback(() => {
    /**
     * Before we instantiate the RainbowKit wallets we need to touch `window.ethereum.isZerion` to ensure
     * that Zerion plays ball and doesn't mutate our page.
     */
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    console.log(`isZerion: ${String(window.ethereum?.isZerion ?? false)}`);
  }, []);
  return (
    <ConnectButton.Custom>
      {({ account, chain, openChainModal, openConnectModal, mounted }) => {
        const ready = mounted;
        const connected = ready && account && chain;
        makeZerionPlayBall();
        return (
          <RainbowKitWalletButtonContainer
            ready={ready}
            {...(!ready && {
              "aria-hidden": true,
            })}
          >
            {(() => {
              if (!connected) {
                return (
                  <ConnectWallet
                    onClick={openConnectModal}
                    isInHeader={!!isInHeader}
                    border={border ?? "smooth"}
                    buttonCss={buttonCss}
                    buttonText={buttonText}
                    showIcon={showIcon}
                  />
                );
              }

              if (chain.unsupported) {
                GlobalStore.update(s => {
                  s.modalSelector = MODAL_SELECTORS.SWITCH_NETWORK;
                });
                return (
                  <button onClick={openChainModal} type="button">
                    Wrong network
                  </button>
                );
              }
            })()}
          </RainbowKitWalletButtonContainer>
        );
      }}
    </ConnectButton.Custom>
  );
};
